import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { GrantAccessDialogLoaderQuery } from './GrantAccessDialogLoaderQuery.graphql';

export function preloadGrantAccessDialogData(contentId: string, accountId: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: GrantAccessDialogLoaderQuery,
		variables: { contentId, accountId },
	});
}
